import { render, staticRenderFns } from "./SysCheckRuleList.vue?vue&type=template&id=2b347d6b&scoped=true&"
import script from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
export * from "./SysCheckRuleList.vue?vue&type=script&lang=js&"
import style0 from "./SysCheckRuleList.vue?vue&type=style&index=0&id=2b347d6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b347d6b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b347d6b')) {
      api.createRecord('2b347d6b', component.options)
    } else {
      api.reload('2b347d6b', component.options)
    }
    module.hot.accept("./SysCheckRuleList.vue?vue&type=template&id=2b347d6b&scoped=true&", function () {
      api.rerender('2b347d6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/SysCheckRuleList.vue"
export default component.exports